import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Panel } from "@/components/Widgets";
import { fmt } from "@/lib/api";

const FILTERS = { all: "All", new: "New", new_sheet: "New sheet", value_changed: "Values changed", matched: "Recognised" };
const STATUS_CLS = { matched: "text-emerald-400", new: "text-rose-400", new_sheet: "text-amber-400", value_changed: "text-sky-400" };

export const PreviewTable = ({ preview, sections }) => {
  const [f, setF] = useState("all");
  const [q, setQ] = useState("");
  const rows = preview.filter((p) => (f === "all" || p.status === f) && `${p.sheet} ${p.label}`.toLowerCase().includes(q.toLowerCase()));
  return (
    <Panel className="mt-6" title="Data-mapping preview" subtitle="Every worksheet row the parser mapped, keyed by sheet · section · label" testid="review-preview-panel"
      actions={<>
        <div className="flex rounded-full border border-slate-700 p-0.5">
          {Object.entries(FILTERS).map(([k, v]) => (
            <button key={k} onClick={() => setF(k)} data-testid={`preview-filter-${k}`}
              className={`rounded-full px-3 py-1 text-xs transition-colors ${f === k ? "bg-amber-500 text-slate-950" : "text-slate-400 hover:text-slate-100"}`}>{v}</button>
          ))}
        </div>
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search label or sheet" className="h-8 w-52 border-slate-700 bg-slate-900/70 text-xs" data-testid="preview-search-input" />
      </>}>
      <div className="max-h-[60vh] overflow-auto rounded-lg border border-slate-800">
        <table className="w-full min-w-[760px] text-sm" data-testid="preview-table">
          <thead className="sticky top-0 bg-[#0f172a]">
            <tr className="text-left text-[11px] uppercase tracking-wider text-slate-500">
              <th className="px-3 py-2">Status</th><th className="px-3 py-2">Worksheet</th><th className="px-3 py-2">Maps to</th><th className="px-3 py-2">Row label</th>
              <th className="px-3 py-2 text-right">Previous Σ</th><th className="px-3 py-2 text-right">This file Σ</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((p) => (
              <tr key={p.key} className="border-t border-slate-800">
                <td className={`px-3 py-1.5 text-xs ${STATUS_CLS[p.status]}`}>{p.status.replace(/_/g, " ")}</td>
                <td className="px-3 py-1.5 text-xs text-slate-400">{p.sheet}</td>
                <td className="px-3 py-1.5 text-xs text-slate-300">{p.kind === "line" ? sections[p.section] : p.kind === "ncf" ? `NCF · ${p.role?.replace(/_/g, " ")}` : p.section === "loan_details" ? "Loan facility" : p.kind}</td>
                <td className="px-3 py-1.5 text-slate-100">{p.label}</td>
                <td className="num px-3 py-1.5 text-right text-xs text-slate-500">{p.prev_total != null ? fmt(p.prev_total) : "–"}</td>
                <td className="num px-3 py-1.5 text-right text-xs">{p.total != null ? fmt(p.total) : "–"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Panel>
  );
};
